





























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class ExternalItem extends Vue {
  @Prop() external;

  @Prop() asset;

  get amountText() {
    const amount = this.external.amount;
    const value = Number(amount);
    return value > 0 ? `+${amount}` : amount;
  }

  get symbol() {
    return (this.asset && this.asset.symbol) || "-";
  }

  get externalText() {
    const confirmation = this.external.confirmations;
    const threshold = this.external.threshold;
    return this.$t("wallet.snapshots.external-item.confirmation-text", {
      number: `${confirmation}/${threshold}`
    });
  }

  get process() {
    const confirmation = this.external.confirmations;
    const threshold = this.external.threshold;
    return ((confirmation / threshold) * 100).toFixed();
  }
}
export default ExternalItem;
